<div class="main_box" id="search_box" [class.active]="searchOpened()" [class.mobile]="mobile()">

  <div #searchbar_container class="searchbar_container">
    <app-icon [hidden]="buscando()" src="/assets/icons/new_design/search.svg" class="search-icon" role="button" tabindex="0" aria-label="Buscar" (click)="submitSearch($event)" (keydown.enter)="submitSearch($event)"></app-icon>
    <app-icon [hidden]="!buscando()" src="/assets/icons/new_design/spin.svg" class="search-icon spin"></app-icon>

    <input
      #searchText
      class="theme-border-radius-6"
      id="searchbr"
      [ngModel]="searchTerm()"
      (ngModelChange)="searchTerm.set($event); search($event)"
      (keydown.enter)="submitSearch($event)"
      (focus)="searchOpened.set(true)"
      type="text"
      autocomplete="off"
      aria-label="Buscar chollos"
      >

    <!-- Búsqueda por voz (odd/tasks/tiendas-voz-cabecera.md, S4); no sale si el navegador no tiene voz. -->
    <span class="voz-slot"><app-boton-voz></app-boton-voz></span>

    <span class="icon close-btn theme-bg theme-text theme-toolbar-search-icon-delete" title="Borrar" [class.hidden]="!searchOpened()" (click)="clearSearch()">
      <svg appIcon src="/assets/icons/new_design/x.svg"></svg>
    </span>

    @if (!searchTerm() && !searchOpened()) {
      <div class="placeholder">Busca <span>entre + de 100 mil chollos</span></div>
    }
  </div>
  @if (searchOpened() || mobile()) {
    <app-top-searches [class.w_100]="mobile()" [mobile]="mobile()" [topSearch]="topSearch()" [suggestions]="suggestions()" [searchTerm]="searchTerm()" (closeBox)="dismiss()"></app-top-searches>
  }
</div>